import { createContext, useContext } from 'react';

import type { OutOfStockContextValue } from './OutOfStock.types';

export const OutOfStockContext = createContext<OutOfStockContextValue | null>(null);

export function useOutOfStock() {
  const context = useContext(OutOfStockContext);
  if (!context) {
    throw new Error('useOutOfStock must be used within an OutOfStock.Root');
  }
  return context;
}
